// import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

export function heroBanner(settings) {
    var heroBanner = tns({
        container: settings.container,
        items: 1,
        autoplay: true,
        autoplayButtonOutput: false,
        controls: false,
        nav: false,
        mouseDrag: true,
    });
}

export function imageSlider(settings) {
    var imageSlider = tns({...settings})
}

export function customSlider(settings) {
    var customSlider = tns({...settings})
}